module.exports = __webpack_public_path__ + "img/left1.1d41594b.jpg";